/*
 * @Author: zhenhui.duan
 * @Date: 2024-07-10 12:02:54
 * @Description:
 */
import Header from '../../components/Header';
import Chart from '../../components/Chart';
import CurrencySelector from '../../components/CurrencySelector';

import RightContent from '../../components/RightContent';
import LeftContent from '../../components/LeftContent';

import './index.less';

export default () => {
  return (
    <div className="currency-layout-sm">
      <Header />
      <CurrencySelector />
      <Chart />
      <div className="currency-main-box">
        <RightContent />
        <LeftContent />
      </div>
    </div>
  );
};
